/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

import type { BvBtnArgs } from '../bv-btn';

interface IAction extends BvBtnArgs {
  visible?: boolean;
  classNames?: string;
}

export interface BvCardSectionSignature {
  Args: {
    actions?: IAction[];
    fullWidth?: boolean;
    subdued?: boolean;
    subtitle?: string;
    title?: string;
  };
  Blocks: {
    actions: [];
    default: [];
    title: [];
  };
  Element: HTMLDivElement;
}

const BvCardSectionComponent = templateOnlyComponent<BvCardSectionSignature>();

export default BvCardSectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCard::Section': typeof BvCardSectionComponent;
    'bv-card/section': typeof BvCardSectionComponent;
  }
}
